import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';

/**
 * FormActionButtons Component
 *
 * Renders Approve/Reject/Send Back action buttons for form approval.
 * Extracted from FormApprove for reusability and single responsibility.
 *
 * @param {Object} props
 * @param {Array} props.actionChildren - Array of child stages (approval types)
 * @param {Function} props.onAction - Callback when an action button is clicked
 * @param {boolean} props.disabled - Whether buttons should be disabled
 * @param {boolean} props.requireComment - Whether comment is required for send back
 * @param {number} props.commentCount - Number of comments (for send back validation)
 */
const FormActionButtons = ({
  actionChildren = [],
  onAction,
  disabled = false,
  requireComment = true,
  commentCount = 0,
}) => {
  const { t } = useTranslation();

  if (!actionChildren || actionChildren.length === 0) {
    return null;
  }

  const handleClick = (child) => {
    if (onAction) {
      onAction(child);
    }
  };

  // Filter children to only show those with ApprovalType
  const actionableChildren = actionChildren.filter(
    (child) => child.ApprovalType
  );

  if (actionableChildren.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '20px',
        gap: '10px',
      }}
    >
      {actionableChildren.map((child) => {
        const isSendBack = child.ApprovalType.code === 'sbk';

        // Disable send back if no comments and comment is required
        const isSendBackDisabled =
          isSendBack && requireComment && commentCount === 0;

        return (
          <Button
            key={child.id}
            color="primary"
            style={{
              padding: '12px 22px',
              width: '157px',
              height: '40px',
            }}
            onClick={() => handleClick(child)}
            disabled={disabled || isSendBackDisabled}
            text={t(child.ApprovalType?.name)}
          />
        );
      })}
    </div>
  );
};

export default FormActionButtons;
